import $ from 'jquery'

export default class MonthPicker {

  constructor(selector) {
    this.$picker = $(selector)
    this.$modal = $('#month-picker-modal')
    this.$years = this.$modal.find('.years a')
    this.$months = this.$modal.find('.months a')
    this.init()

  }

  init() {
    this.$years.on('click', (e) => this.on_year_click(e))
  }

  on_year_click(e) {
    this.$years.removeClass('active')
    $(e.target).addClass('active')

    let y = $(e.target).text()
    this.$months.each(function(){
      let href = $(this).attr('href')
      $(this).attr('href', href.replace(/[0-9]{4}/, y))
    })

  }

}



// WEBPACK FOOTER //
// ./utils/static/utils/js/month-picker.js